import { sendRequest } from "@/core/hooks/useApiQueries/sendRequest";
import type {
  AgentPromptVersionDetail,
  AgentPromptVersionSummary,
} from "@superagents/types/api";

export const agentPromptVersionsKey = (sectorId: string) =>
  ["agent-prompt-versions", sectorId] as const;

export const agentPromptVersionKey = (sectorId: string, versionId: string) =>
  ["agent-prompt-version", sectorId, versionId] as const;

export const AGENT_PROMPT_VERSIONS_PAGE_SIZE = 20;

export type AgentPromptVersionsPage = {
  items: AgentPromptVersionSummary[];
  page: number;
  total: number;
};

/** Histórico de versões do prompt do agente do setor ativo (SA-1486). */
export const agentPromptVersionsApi = {
  /** Uma página, da versão mais recente para a mais antiga. */
  async list(
    token: string | undefined,
    sectorId: string,
    page: number
  ): Promise<AgentPromptVersionsPage> {
    const response = await sendRequest(token, {
      method: "GET",
      url: "/agent/prompt-versions",
      params: { sectorId, page, pageSize: AGENT_PROMPT_VERSIONS_PAGE_SIZE },
    });
    const { data, meta } = response.data as {
      data: AgentPromptVersionSummary[];
      meta: { pagination: { page: number; total: number } };
    };
    return {
      items: data,
      page: meta.pagination.page,
      total: meta.pagination.total,
    };
  },

  async get(
    token: string | undefined,
    sectorId: string,
    versionId: string
  ): Promise<AgentPromptVersionDetail> {
    const response = await sendRequest(token, {
      method: "GET",
      url: `/agent/prompt-versions/${versionId}`,
      params: { sectorId },
    });
    return response.data.data as AgentPromptVersionDetail;
  },
};
